import React from 'react';
import { education } from '../../portfolio';

const Education = () => {
  return (
    <section className="section">
      <div className="section-header">
        <h1 className="section-title">Education</h1>
        <p className="section-subtitle">Academic background and degrees.</p>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
        {education.map((edu, idx) => (
          <div key={idx} className="list-card" style={{ padding: '32px', background: 'var(--surface)', borderRadius: 'var(--radius)', border: '1px solid var(--border)' }}>
            <h4 style={{ fontSize: '20px', fontWeight: 600, color: 'var(--text-1)', marginBottom: '8px' }}>{edu.degree}</h4>
            <div style={{ fontSize: '15px', color: 'var(--text-1)', fontWeight: 500, marginBottom: '6px' }}>{edu.institution}</div>
            <div style={{ fontSize: '14px', color: 'var(--text-3)', marginBottom: '20px' }}>{edu.duration} • {edu.location}</div>
            <p style={{ fontSize: '15px', color: 'var(--text-2)', lineHeight: 1.7 }}>{edu.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Education;
